import { Route, Routes } from "react-router-dom";
import SecureRoute from "../Elements/SecureRoute";
import SurveyList from "../Views/MX Surveys/SurveysList";
import SurveyManageList from "../Views/MX Surveys/SurveysManage";
import AddSurvey from "../Views/MX Surveys/AddSurvey";
import SurveyDetails from "../Views/MX Surveys/SurveyDetails";

function SurveyRoutes() {
  return (
    <Routes>
      <Route index element={<SecureRoute element={<SurveyList />} />} />
      <Route
        path="/my"
        element={
          <SecureRoute
            level={["LCVP TM", "MCVP TM"]}
            element={<SurveyManageList />}
          />
        }
      />
      <Route
        path="/add"
        element={
          <SecureRoute level={["LCVP TM", "MCVP TM"]} element={<AddSurvey />} />
        }
      />
      <Route
        path="/:id"
        element={
          <SecureRoute
            level={["LCVP TM", "MCVP TM"]}
            element={<SurveyDetails />}
          />
        }
      />
    </Routes>
  );
}
export default SurveyRoutes;
